import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import "./inferenceDetailsComponent.css";
import { Divider, IconButton, Typography, Button, Tab, Tabs, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Select, MenuItem, Box, Fab } from "@mui/material";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { nextSteps, extractFollowUpDate, handleSetReferral } from "../../utlis";



// const handleNextDate = (left, right) => {
//     const currentDate = new Date();
//     let nextStepDate = new Date();
//     let message = "";
//     if(
//         left === "Non Gradable Image" ||
//         right === "Non Gradable Image"||
//         left === "Severe Diabetic Retinopathy" ||
//         right === "Severe Diabetic Retinopathy" ||
//         left === "Proliferative Diabetic Retinopathy" ||
//         right === "Proliferative Diabetic Retinopathy"
//     ) {
//         nextStepDate.setMonth(currentDate.getMonth() + 3);
//         message = "Referral required immediately  and ask for a follow up visit after 3 Months on";
//     }
//     else if (left === "Moderate Diabetic Retinopathy" || right === "Moderate Diabetic Retinopathy") {
//         nextStepDate.setMonth(currentDate.getMonth() + 6);
//         message = "Referral required within 3-6 months and ask for a follow up visit after 6 Months on";
//     }
//     else if (
//         left === "No Diabetic Retinopathy" ||
//         right === "No Diabetic Retinopathy" ||
//         left === "Mild Diabetic Retinopathy" ||
//         right === "Mild Diabetic Retinopathy"
//     ) {
//         nextStepDate.setFullYear(currentDate.getFullYear() + 1);
//         message = "Referral not required and ask for a follow up visit after a year on";
//     }

//     const formattedDate = nextStepDate.toDateString().split(' ').slice(1).join(' ');

//     return { date: formattedDate, message };
// };

const eyeInferenceDiv = (inf, isOverride = false) => {
    if (isOverride) {
        return `eyeInferenceDivOverride`;
    }
    if (inf === "No Diabetic Retinopathy") {
        return `eyeInferenceDivNoDR`;
    }
    if (inf === "Mild Diabetic Retinopathy") {
        return `eyeInferenceDivMildDR`;
    }
    if (inf === "Moderate Diabetic Retinopathy") {
        return `eyeInferenceDivModDR`;
    }
    if (inf === "Proliferative Diabetic Retinopathy") {
        return `eyeInferenceDivProDR`;
    }
    if (inf === "Severe Diabetic Retinopathy") {
        return `eyeInferenceDivSevDR`;
    }
    if (inf === "Non Gradable Image") {
        return `eyeInferenceDivHazy`;
    }
};

const eyeInferenceText = (inf, isOverride = false) => {
    if (isOverride) {
        return `eyeInferenceTextOverride`;
    }
    if (inf === "No Diabetic Retinopathy") {
        return `eyeInferenceTextNoDR`;
    }
    else if (inf === "Mild Diabetic Retinopathy") {
        return `eyeInferenceTextMildDR`;
    }
    else if (inf === "Moderate Diabetic Retinopathy") {
        return `eyeInferenceTextModDR`;
    }
    else if (inf === "Proliferative Diabetic Retinopathy") {
        return `eyeInferenceTextProDR`;
    }
    else if (inf === "Severe Diabetic Retinopathy") {
        return `eyeInferenceTextSevDR`;
    }
    if (inf === "Non Gradable Image") {
        return `eyeInferenceTextHazy`;
    }
};

const requiredInferenceDiv = (inf) => {
    if (inf === "Required") {
        return "reqInfDiv";
    }
    else if (inf === "Not Required") {
        return "notRegInfDiv";
    }
};

const requiredInferenceText = (inf) => {
    if (inf === "Required") {
        return "reqInfText";
    }
    else if (inf === "Not Required") {
        return "notReqInfText";
    }
};

const ImageDiv = (inf) => {
    if (inf === "No Diabetic Retinopathy") {
        return `imageDivNoDR`;
    }
    if (inf === "Mild Diabetic Retinopathy") {
        return `imageDivMildDR`;
    }
    if (inf === "Moderate Diabetic Retinopathy") {
        return `imageDivModDR`;
    }
    if (inf === "Proliferative Diabetic Retinopathy") {
        return `imageDivProDR`;
    }
    if (inf === "Severe Diabetic Retinopathy") {
        return `imageDivSevDR`;
    }
    if (inf === "Non Gradable Image") {
        return `imageDivHazy`;
    }
};

const InferenceDetailsComponent = forwardRef(({ edit, handleImageEditClick, patientrecordId, leftImage, rightImage, leftInference, rightInference, required, feedbackData, formik, leftModelScore, rightModelScore, nextStepsData = null, singleImageReason = null, ophthalmologistLeftInference = null, ophthalmologistRightInference = null, ophthalmologistLeftDME = null, ophthalmologistRightDME = null, operatorOverride = { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } }, modelOutputs = { left: null, right: null }, onValidityChange = () => {} }, ref) => {
    // Helper function to check if inference is "Image Not Available"
    const isImageNotAvailable = (inference) => {
        // Check for various forms of "Image Not Available"
        return inference?.includes("Image Not Available") || 
               inference === undefined || 
               inference === null ||
               inference === "";
    };
    
    // Get DME information from modelOutputs
    const leftDME = modelOutputs?.left?.drdme?.DME_grade || null;
    const rightDME = modelOutputs?.right?.drdme?.DME_grade || null;

    // Get operator override information (use prop if provided, otherwise default)
    const operatorOverrideData = operatorOverride || { left: { fundus: false, eye: false }, right: { fundus: false, eye: false } };

    // Shared DME display flags (used by both badge rendering and the DME confirmation toggle)
    const isRightFundusOverride = operatorOverrideData?.right?.fundus || false;
    const isLeftFundusOverride = operatorOverrideData?.left?.fundus || false;
    const isRightDME = rightDME === "DME";
    const isLeftDME = leftDME === "DME";
    const showRightDME = !isRightFundusOverride && rightDME;
    const showLeftDME = !isLeftFundusOverride && leftDME;
    
    // Get default nextSteps data
    let { date, message } = nextSteps(leftInference, rightInference, leftDME, rightDME, operatorOverrideData);
    // If nextStepsData is present, override the values
    if (nextStepsData) {
        date = extractFollowUpDate(nextStepsData);
        message = nextStepsData.split(' on ')[0]; // Extract only the message part, not the date
    }
    const leftScore = formik
    ? formik?.values?.image_file?.left?.classification?.model_score
    : leftModelScore;

    const rightScore = formik
    ? formik?.values?.image_file?.right?.classification?.model_score
    : rightModelScore;

    const [view, setView] = useState("right");

    // State for inference correction - separate for each eye (DR)
    const [rightEyeCorrect, setRightEyeCorrect] = useState('');
    const [leftEyeCorrect, setLeftEyeCorrect] = useState('');
    const [rightEyeCorrectedInference, setRightEyeCorrectedInference] = useState('');
    const [leftEyeCorrectedInference, setLeftEyeCorrectedInference] = useState('');

    // State for DME confirmation - separate for each eye. For a normal eye, this is a Yes/No
    // toggle and "No" implies the corrected value is simply the opposite of the AI grade. For
    // an abstained eye, there's no separate DME toggle at all - the single DR "Is the AI
    // Inference Correct?" toggle covers both, and when "No", this same state is reused to hold
    // the dropdown-picked DME status directly (the two uses never overlap: showRightDME and
    // isRightFundusOverride are mutually exclusive, so nothing here needs to serve both at once).
    const [rightEyeDMECorrect, setRightEyeDMECorrect] = useState('');
    const [leftEyeDMECorrect, setLeftEyeDMECorrect] = useState('');

    const [optometristRole, setOptometristRole] = useState(null);

    // State for generic radio buttons
    const [serviceProvided, setServiceProvided] = useState('');
    const [furtherReferralRequired, setFurtherReferralRequired] = useState('');

    const serviceProvidedOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
        { value: 'not_needed', label: 'Not needed' },
    ];

    // Auto-lock logic: the "final grade" is the same both-eyes-combined signal already
    // used everywhere else in the app (patient list header color, referral banner) -
    // reuse handleSetReferral's combining rules rather than a separate ad-hoc check.
    // Lock only when that verdict is "Not Required" (both eyes DR negative - No DR or
    // Mild - AND neither eye has DME AND no operator override; see handleSetReferral
    // in utlis.js for the full monocular/override rules this already encodes).
    const overallReferralStatus = handleSetReferral(
        leftInference,
        rightInference,
        singleImageReason,
        operatorOverrideData,
        { left: leftDME, right: rightDME }
    );
    const isFinalGradeNegative = overallReferralStatus === "Not Required";

    const anyConditionFlaggedIncorrect = [rightEyeCorrect, leftEyeCorrect, rightEyeDMECorrect, leftEyeDMECorrect].includes('no');
    const isDispositionLocked = isFinalGradeNegative && !anyConditionFlaggedIncorrect;

    // "Not needed" doesn't make clinical sense once there's a real DR finding (not No DR, not
    // Non Gradable) together with DME present somewhere - grey that option out rather than
    // letting it be picked. DME present already forces isFinalGradeNegative to "Required" via
    // handleSetReferral's DME-override rule, so this never overlaps with isDispositionLocked above.
    const hasRealDRFinding = (inf) => inf && inf !== "No Diabetic Retinopathy" && inf !== "Non Gradable Image";
    const isPositiveFinding =
        (hasRealDRFinding(leftInference) || hasRealDRFinding(rightInference)) &&
        (leftDME === "DME" || rightDME === "DME");

    useEffect(() => {
        if (isDispositionLocked) {
            setServiceProvided('not_needed');
            setFurtherReferralRequired('no');
        }
    }, [isDispositionLocked]);

    const correctionOptions = [
        'No Diabetic Retinopathy',
        'Mild Diabetic Retinopathy',
        'Moderate Diabetic Retinopathy',
        'Severe Diabetic Retinopathy',
        'Proliferative Diabetic Retinopathy',
        'Non Gradable Image'
    ];

    // DME correction options for an abstained eye's dropdown (see renderCorrectionDropdown)
    const dmeCorrectionOptions = ['No DME', 'DME'];
    const getDMECorrectionLabel = (option) => option === 'DME' ? 'Suggestive of DME' : 'Non suggestive of DME';

    // Display mapping for better user experience
    const getDisplayText = (option) => {
        // No mapping needed since we're using the display text as the actual value
        return option;
    };

    const getDMEOpinionText = (dme) =>
        dme === "DME" ? "Diabetic Macular Edema (DME) present" : "Diabetic Macular Edema (DME) absent";

    useEffect(() => {
        // Get the optometrist role from localStorage
        const role = localStorage.getItem("optometrist_role");
        setOptometristRole(role);
    }, []);

    // Helper function to get the inference label text
    // Shows "Ophthalmologist opinion:" if feedback exists and inference was corrected (is_correct === "no")
    // Otherwise shows "AI Inference:"
    const getInferenceLabel = (hasImage, eye) => {
        if (!hasImage) {
            return "Image Not Available:";
        }
        // Check if feedback exists and if this specific eye's inference was corrected
        if (feedbackData) {
            if (eye === "right" && feedbackData.right_eye_inference_is_correct === "no") {
                return "Ophthalmologist opinion:";
            }
            if (eye === "left" && feedbackData.left_eye_inference_is_correct === "no") {
                return "Ophthalmologist opinion:";
            }
        }
        return "AI Inference:";
    };

    // Reset all correction data when patientrecordId changes
    useEffect(() => {
        if (patientrecordId) {
            setRightEyeCorrect('');
            setLeftEyeCorrect('');
            setRightEyeCorrectedInference('');
            setLeftEyeCorrectedInference('');
            setRightEyeDMECorrect('');
            setLeftEyeDMECorrect('');
            setServiceProvided('');
            setFurtherReferralRequired('');
        }
    }, [patientrecordId]);

    // Mirrors the same rules reportsComponent.js's handleSubmit already validates on click -
    // reported here too so the Submit button can be proactively disabled instead of only
    // alerting after the ophthalmologist has already clicked it.
    useEffect(() => {
        const rightNeedsCorrection = !isImageNotAvailable(rightInference) && rightEyeCorrect === 'no' && !rightEyeCorrectedInference;
        const leftNeedsCorrection = !isImageNotAvailable(leftInference) && leftEyeCorrect === 'no' && !leftEyeCorrectedInference;
        onValidityChange(!rightNeedsCorrection && !leftNeedsCorrection);
    }, [rightInference, leftInference, rightEyeCorrect, leftEyeCorrect, rightEyeCorrectedInference, leftEyeCorrectedInference, onValidityChange]);

    const handleRightEyeCorrectChange = (event) => {
        setRightEyeCorrect(event.target.value);
        if (event.target.value === 'yes') {
            setRightEyeCorrectedInference('');
            // Abstained eyes reuse rightEyeDMECorrect to hold the dropdown-picked DME status -
            // clear it here too. Normal eyes have their own independent DME toggle, untouched.
            if (isRightFundusOverride) {
                setRightEyeDMECorrect('');
            }
        }
    };

    const handleLeftEyeCorrectChange = (event) => {
        setLeftEyeCorrect(event.target.value);
        if (event.target.value === 'yes') {
            setLeftEyeCorrectedInference('');
            if (isLeftFundusOverride) {
                setLeftEyeDMECorrect('');
            }
        }
    };

    const handleRightEyeDMECorrectChange = (event) => {
        setRightEyeDMECorrect(event.target.value);
    };

    const handleLeftEyeDMECorrectChange = (event) => {
        setLeftEyeDMECorrect(event.target.value);
    };

    const handleRightEyeCorrectedInferenceChange = (event) => {
        setRightEyeCorrectedInference(event.target.value);
    };

    const handleLeftEyeCorrectedInferenceChange = (event) => {
        setLeftEyeCorrectedInference(event.target.value);
    };

    const handleServiceProvidedChange = (event) => {
        setServiceProvided(event.target.value);
    };

    const handleFurtherReferralRequiredChange = (event) => {
        setFurtherReferralRequired(event.target.value);
    };

    const handleTabChange = (event, newValue) => {
        setView(newValue);
    };

    const [selectedImage, setSelectedImage] = useState(null);
    const [open, setOpen] = useState(false);
    const [eye, setEye] = useState("");

    const handleImageClick = (imgSrc, eye) => {
        setSelectedImage(imgSrc);
        setOpen(true);
        setEye(eye);
    };

    const handleCloseModal = () => {
        setOpen(false);
        setSelectedImage(null);
    };

    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);

    const handleTouchStart = (e) => {
        setTouchStartX(e.changedTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEndX(e.changedTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        const swipeThreshold = 50; // pixels
        const deltaX = touchEndX - touchStartX;

        if (deltaX > swipeThreshold && view === "left") {
            setView("right"); // Swipe right
        } else if (deltaX < -swipeThreshold && view === "right") {
            setView("left"); // Swipe left
        }
    };

    useImperativeHandle(ref, () => ({
        getFormData() {
            const formData = {
                patientrecordId,
                serviceProvided,
                furtherReferralRequired
            };
            
            // Only include right eye feedback if image is available
            if (!isImageNotAvailable(rightInference)) {
                formData.rightEyeCorrect = rightEyeCorrect;
                formData.rightEyeCorrectedInference = rightEyeCorrectedInference;
            }

            // Only include left eye feedback if image is available
            if (!isImageNotAvailable(leftInference)) {
                formData.leftEyeCorrect = leftEyeCorrect;
                formData.leftEyeCorrectedInference = leftEyeCorrectedInference;
            }

            // DME confirmation is only asked when a DME badge is actually shown
            if (showRightDME) {
                formData.rightEyeDMECorrect = rightEyeDMECorrect;
                formData.rightEyeCorrectedDME = rightEyeDMECorrect === 'no' ? (isRightDME ? 'No DME' : 'DME') : '';
            } else if (isRightFundusOverride && rightEyeCorrect === 'no') {
                // Abstained eye: the single DR toggle stands in for DME confirmation too -
                // rightEyeDMECorrect holds the dropdown-picked grade directly here (see its
                // declaration above), reusing the same payload shape as a normal eye's DME correction.
                formData.rightEyeDMECorrect = 'no';
                formData.rightEyeCorrectedDME = rightEyeDMECorrect;
            }
            if (showLeftDME) {
                formData.leftEyeDMECorrect = leftEyeDMECorrect;
                formData.leftEyeCorrectedDME = leftEyeDMECorrect === 'no' ? (isLeftDME ? 'No DME' : 'DME') : '';
            } else if (isLeftFundusOverride && leftEyeCorrect === 'no') {
                formData.leftEyeDMECorrect = 'no';
                formData.leftEyeCorrectedDME = leftEyeDMECorrect;
            }

            return formData;
        }
    }));

    // Per-eye data lookup, so the (structurally identical) AI inference / confirmation JSX
    // below can be written once per view size and called for both eyes, instead of once per
    // eye per view (was previously duplicated 4 ways: right-web, left-web, right-mobile, left-mobile).
    const eyePanelData = {
        right: {
            image: rightImage,
            inference: rightInference,
            isFundusOverride: isRightFundusOverride,
            isDME: isRightDME,
            showDME: showRightDME,
            eyeCorrect: rightEyeCorrect,
            onEyeCorrectChange: handleRightEyeCorrectChange,
            correctedInference: rightEyeCorrectedInference,
            onCorrectedInferenceChange: handleRightEyeCorrectedInferenceChange,
            eyeDMECorrect: rightEyeDMECorrect,
            onEyeDMECorrectChange: handleRightEyeDMECorrectChange,
            ophthalmologistInference: ophthalmologistRightInference,
            ophthalmologistDME: ophthalmologistRightDME,
        },
        left: {
            image: leftImage,
            inference: leftInference,
            isFundusOverride: isLeftFundusOverride,
            isDME: isLeftDME,
            showDME: showLeftDME,
            eyeCorrect: leftEyeCorrect,
            onEyeCorrectChange: handleLeftEyeCorrectChange,
            correctedInference: leftEyeCorrectedInference,
            onCorrectedInferenceChange: handleLeftEyeCorrectedInferenceChange,
            eyeDMECorrect: leftEyeDMECorrect,
            onEyeDMECorrectChange: handleLeftEyeDMECorrectChange,
            ophthalmologistInference: ophthalmologistLeftInference,
            ophthalmologistDME: ophthalmologistLeftDME,
        },
    };

    // DME confirmation toggle (Yes/No pill pair) - identical between eyes and between the
    // web/mobile size variants except for font size, so it's factored out of both render
    // functions below rather than duplicated a 3rd/4th time inside each of them.
    const renderYesNoToggle = (currentValue, onChange, fontSize) => (
        <div style={{ display: "flex", gap: "12px" }}>
            {['yes', 'no'].map((value) => (
                <div
                    key={value}
                    style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "2px 8px",
                        backgroundColor: currentValue === value ? (value === 'yes' ? "#075400" : "#9F0101") : "#fff",
                        borderColor: currentValue === value ? (value === 'yes' ? "#075400" : "#9F0101") : "#e0e0e0"
                    }}
                >
                    <FormControlLabel
                        value={value}
                        control={
                            <Radio
                                checked={currentValue === value}
                                onChange={onChange}
                                value={value}
                                size="small"
                                sx={{ color: "#ccc", "&.Mui-checked": { color: "#fff" } }}
                            />
                        }
                        label={<Typography fontSize={fontSize} color={currentValue === value ? "#fff" : "#000"}>{value === 'yes' ? 'Yes' : 'No'}</Typography>}
                    />
                </div>
            ))}
        </div>
    );

    // Shared correction dropdown - used for both the DR correction picker (every eye) and the
    // DME status picker (abstained eyes only, see renderWebEyeInferenceBlock/renderMobileEyeInferenceBlock).
    // marginTop/labelFontSize match the surrounding block's sizing (web vs mobile).
    const renderCorrectionDropdown = ({ labelText, placeholderText, value, onChange, options, getOptionLabel, isOptionDisabled, marginTop, labelFontSize }) => (
        <FormControl sx={{ marginTop, width: "100%" }}>
            <FormLabel sx={{ color: "#051572", fontWeight: 600, fontSize: labelFontSize, marginBottom: labelFontSize === "12px" ? "6px" : "8px" }}>
                {labelText}
            </FormLabel>
            <Select
                value={value}
                onChange={onChange}
                displayEmpty
                size="small"
                MenuProps={{ PaperProps: { style: { maxWidth: '25vw', maxHeight: 300 } } }}
                sx={{
                    backgroundColor: "#fff", fontSize: "14px", width: "100%", maxWidth: "100%", minHeight: "40px",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ddd", borderRadius: "8px" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#051572" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#051572", borderWidth: "2px" },
                    "& .MuiSelect-select": { padding: "8px 12px", fontSize: "14px", color: value ? "#000" : "#999" },
                }}
            >
                <MenuItem value="" disabled>
                    <em style={{ color: "#999", fontSize: "14px" }}>{placeholderText}</em>
                </MenuItem>
                {options.map((option) => {
                    const disabled = isOptionDisabled ? isOptionDisabled(option) : false;
                    return (
                        <MenuItem key={option} value={option} disabled={disabled} sx={{ padding: "8px 12px", opacity: disabled ? 0.5 : 1, color: disabled ? "#999" : "#000" }}>
                            <Typography fontSize="14px" color={disabled ? "#999" : "#000"}>
                                {getOptionLabel(option)}
                            </Typography>
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );

    // Web-size (desktop) AI inference block for one eye: DME badge, DME confirmation,
    // DR badge, DR confirmation + correction dropdown, and the read-only Ophthalmologist
    // opinion summary once feedback has been submitted.
    const renderWebEyeInferenceBlock = (eyeKey) => {
        const d = eyePanelData[eyeKey];
        const displayText = d.isFundusOverride ? "Abstained due to operator override" : d.inference;
        return (
            <div style={{ padding: "2% 0" }}>
                <Typography fontWeight="bold" fontSize="16px">
                    AI Inference:
                </Typography>
                {d.image ? (
                    <>
                        {d.showDME && (
                            <div
                                className={d.isDME ? "dmeDivPresent" : "dmeDivAbsent"}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "1.5%", marginBottom: "0.5rem"
                                }}
                            >
                                <Typography className={d.isDME ? "dmeTextPresent" : "dmeTextAbsent"} fontWeight={400} fontSize="16px">
                                    {getDMEOpinionText(d.isDME ? "DME" : "No DME")}
                                </Typography>
                            </div>
                        )}
                        {optometristRole === "Ophthalmologist" && !feedbackData && d.showDME && (
                            <Box sx={{ marginBottom: "12px", padding: "12px", backgroundColor: "#F6FBFF", borderRadius: "8px", border: "1px solid #e0e0e0", width: "25vw", boxSizing: "border-box" }}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend" sx={{ color: "#0D1E83", fontWeight: 600, fontSize: "14px", marginBottom: "8px" }}>
                                        Is the AI Inference Correct?
                                    </FormLabel>
                                    {renderYesNoToggle(d.eyeDMECorrect, d.onEyeDMECorrectChange, "14px")}
                                </FormControl>
                            </Box>
                        )}
                        <div
                            className={eyeInferenceDiv(d.inference, d.isFundusOverride)}
                            style={{
                                borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                width: "fit-content", padding: "1.5%", marginBottom: feedbackData ? "12px" : "0"
                            }}
                        >
                            <Typography className={eyeInferenceText(d.inference, d.isFundusOverride)} fontWeight={400} fontSize="16px">
                                {displayText}
                            </Typography>
                        </div>
                    </>
                ) : (
                    <div style={{
                        borderRadius: "8px", border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9",
                        padding: "8px 12px", width: "fit-content", marginBottom: feedbackData ? "12px" : "0"
                    }}>
                        <Typography fontWeight={400} fontSize="16px" color="#666">
                            {singleImageReason || formik?.values?.image_file?.single_image_reason || "Single image mode"}
                        </Typography>
                    </div>
                )}

                {/* Show Ophthalmologist opinion when feedback exists - one header, DME then DR */}
                {feedbackData && d.image && (d.ophthalmologistDME || d.ophthalmologistInference) && (
                    <>
                        <Typography fontWeight="bold" fontSize="16px" style={{ marginTop: "12px" }}>
                            Ophthalmologist opinion:
                        </Typography>
                        {d.ophthalmologistDME && d.ophthalmologistInference !== "Non Gradable Image" && (
                            <div
                                className={d.ophthalmologistDME === "DME" ? "dmeDivPresent" : "dmeDivAbsent"}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "1.5%", marginBottom: d.ophthalmologistInference ? "0.5rem" : "0"
                                }}
                            >
                                <Typography className={d.ophthalmologistDME === "DME" ? "dmeTextPresent" : "dmeTextAbsent"} fontWeight={400} fontSize="16px">
                                    {getDMEOpinionText(d.ophthalmologistDME)}
                                </Typography>
                            </div>
                        )}
                        {d.ophthalmologistInference && (
                            <div
                                className={eyeInferenceDiv(d.ophthalmologistInference)}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "1.5%"
                                }}
                            >
                                <Typography className={eyeInferenceText(d.ophthalmologistInference)} fontWeight={400} fontSize="16px">
                                    {d.ophthalmologistInference}
                                </Typography>
                            </div>
                        )}
                    </>
                )}

                {/* AI Inference Correction - Only for Ophthalmologists */}
                {optometristRole === "Ophthalmologist" && !feedbackData && !isImageNotAvailable(d.inference) && (
                    <Box sx={{ marginTop: "12px", padding: "12px", backgroundColor: "#F6FBFF", borderRadius: "8px", border: "1px solid #e0e0e0", width: "25vw", boxSizing: "border-box" }}>
                        <FormControl component="fieldset" sx={{ marginBottom: "8px" }}>
                            <FormLabel component="legend" sx={{ color: "#0D1E83", fontWeight: 600, fontSize: "14px", marginBottom: "8px" }}>
                                Is the AI Inference Correct?
                            </FormLabel>
                            {renderYesNoToggle(d.eyeCorrect, d.onEyeCorrectChange, "14px")}
                        </FormControl>

                        {/* Correction dropdown(s) - only show when "No" is selected */}
                        {d.eyeCorrect === 'no' && (
                            <>
                                {renderCorrectionDropdown({
                                    labelText: "Please select the correct diagnosis*",
                                    placeholderText: "Select correct diagnosis",
                                    value: d.correctedInference,
                                    onChange: d.onCorrectedInferenceChange,
                                    options: correctionOptions,
                                    getOptionLabel: getDisplayText,
                                    // Abstained eyes never showed the AI grade to the ophthalmologist
                                    // ("Abstained due to operator override" is displayed instead), so
                                    // there's nothing to steer them away from - leave every grade pickable.
                                    isOptionDisabled: (option) => !d.isFundusOverride && option === d.inference,
                                    marginTop: "8px",
                                    labelFontSize: "14px",
                                })}
                                {/* Abstained eyes have no separate DME toggle - this single "No" also
                                    covers DME, so ask for the correct DME status here too. */}
                                {d.isFundusOverride && renderCorrectionDropdown({
                                    labelText: "Please select the correct DME status*",
                                    placeholderText: "Select the correct DME status",
                                    value: d.eyeDMECorrect,
                                    onChange: d.onEyeDMECorrectChange,
                                    options: dmeCorrectionOptions,
                                    getOptionLabel: getDMECorrectionLabel,
                                    marginTop: "8px",
                                    labelFontSize: "14px",
                                })}
                            </>
                        )}
                    </Box>
                )}
            </div>
        );
    };

    // Mobile-size AI inference block for one eye - same structure as the web version above,
    // with mobile-specific font sizes/padding/whitespace handling.
    const renderMobileEyeInferenceBlock = (eyeKey) => {
        const d = eyePanelData[eyeKey];
        const displayText = d.isFundusOverride ? "Abstained due to operator override" : d.inference;
        return (
            <div style={{ padding: "1rem" }}>
                <Typography fontWeight="bold" fontSize="16px">
                    AI Inference:
                </Typography>
                {d.image ? (
                    <>
                        {d.showDME && (
                            <div
                                className={d.isDME ? "dmeDivPresent" : "dmeDivAbsent"}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "0.5rem 0.5rem", marginTop: "0.5rem", marginBottom: "0.5rem",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                <Typography className={d.isDME ? "dmeTextPresent" : "dmeTextAbsent"} fontWeight={400} fontSize="14px">
                                    {getDMEOpinionText(d.isDME ? "DME" : "No DME")}
                                </Typography>
                            </div>
                        )}
                        {optometristRole === "Ophthalmologist" && !feedbackData && d.showDME && (
                            <Box sx={{ marginBottom: "8px", padding: "8px", backgroundColor: "#F6FBFF", borderRadius: "6px", border: "1px solid #e0e0e0", width: "100%", boxSizing: "border-box" }}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend" sx={{ color: "#0D1E83", fontWeight: 600, fontSize: "12px", marginBottom: "6px" }}>
                                        Is the AI Inference Correct?
                                    </FormLabel>
                                    {renderYesNoToggle(d.eyeDMECorrect, d.onEyeDMECorrectChange, "12px")}
                                </FormControl>
                            </Box>
                        )}
                        <div
                            className={eyeInferenceDiv(d.inference, d.isFundusOverride)}
                            style={{
                                borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                width: "fit-content", padding: "0.5rem 0.5rem",
                                marginTop: d.showDME ? "0" : "0.5rem",
                                marginBottom: feedbackData ? "12px" : "0",
                                whiteSpace: "nowrap"
                            }}
                        >
                            <Typography className={eyeInferenceText(d.inference, d.isFundusOverride)} fontWeight={400} fontSize="14px">
                                {displayText}
                            </Typography>
                        </div>
                    </>
                ) : (
                    <div style={{
                        borderRadius: "8px", border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9",
                        padding: "6px 10px", width: "fit-content", marginTop: "0.5rem",
                        marginBottom: feedbackData ? "12px" : "0"
                    }}>
                        <Typography fontWeight={400} fontSize="14px" color="#666">
                            {singleImageReason || formik?.values?.image_file?.single_image_reason || "Single image mode"}
                        </Typography>
                    </div>
                )}

                {/* Show Ophthalmologist opinion when feedback exists - one header, DME then DR */}
                {feedbackData && d.image && (d.ophthalmologistDME || d.ophthalmologistInference) && (
                    <>
                        <Typography fontWeight="bold" fontSize="16px" style={{ marginTop: "12px" }}>
                            Ophthalmologist opinion:
                        </Typography>
                        {d.ophthalmologistDME && d.ophthalmologistInference !== "Non Gradable Image" && (
                            <div
                                className={d.ophthalmologistDME === "DME" ? "dmeDivPresent" : "dmeDivAbsent"}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "0.5rem 0.5rem", marginTop: "0.5rem", whiteSpace: "nowrap"
                                }}
                            >
                                <Typography className={d.ophthalmologistDME === "DME" ? "dmeTextPresent" : "dmeTextAbsent"} fontWeight={400} fontSize="14px">
                                    {getDMEOpinionText(d.ophthalmologistDME)}
                                </Typography>
                            </div>
                        )}
                        {d.ophthalmologistInference && (
                            <div
                                className={eyeInferenceDiv(d.ophthalmologistInference)}
                                style={{
                                    borderRadius: "8px", border: "1px solid", display: "flex", justifyContent: "center",
                                    width: "fit-content", padding: "0.5rem 0.5rem", marginTop: "0.5rem", whiteSpace: "nowrap"
                                }}
                            >
                                <Typography className={eyeInferenceText(d.ophthalmologistInference)} fontWeight={400} fontSize="14px">
                                    {d.ophthalmologistInference}
                                </Typography>
                            </div>
                        )}
                    </>
                )}

                {/* AI Inference Correction - Only for Ophthalmologists - Mobile */}
                {optometristRole === "Ophthalmologist" && !feedbackData && !isImageNotAvailable(d.inference) && (
                    <Box sx={{ marginTop: "8px", padding: "8px", backgroundColor: "#F6FBFF", borderRadius: "6px", border: "1px solid #e0e0e0", width: "100%", boxSizing: "border-box" }}>
                        <FormControl component="fieldset" sx={{ marginBottom: "6px" }}>
                            <FormLabel component="legend" sx={{ color: "#0D1E83", fontWeight: 600, fontSize: "12px", marginBottom: "6px" }}>
                                Is the AI Inference Correct?
                            </FormLabel>
                            {renderYesNoToggle(d.eyeCorrect, d.onEyeCorrectChange, "12px")}
                        </FormControl>

                        {/* Correction dropdown(s) - only show when "No" is selected */}
                        {d.eyeCorrect === 'no' && (
                            <>
                                {renderCorrectionDropdown({
                                    labelText: "Select correct diagnosis*",
                                    placeholderText: "Select correct diagnosis",
                                    value: d.correctedInference,
                                    onChange: d.onCorrectedInferenceChange,
                                    options: correctionOptions,
                                    getOptionLabel: getDisplayText,
                                    // See the web block above - abstained eyes disable nothing.
                                    isOptionDisabled: (option) => !d.isFundusOverride && option === d.inference,
                                    marginTop: "6px",
                                    labelFontSize: "12px",
                                })}
                                {/* Abstained eyes have no separate DME toggle - this single "No" also
                                    covers DME, so ask for the correct DME status here too. */}
                                {d.isFundusOverride && renderCorrectionDropdown({
                                    labelText: "Select the correct DME status*",
                                    placeholderText: "Select the correct DME status",
                                    value: d.eyeDMECorrect,
                                    onChange: d.onEyeDMECorrectChange,
                                    options: dmeCorrectionOptions,
                                    getOptionLabel: getDMECorrectionLabel,
                                    marginTop: "6px",
                                    labelFontSize: "12px",
                                })}
                            </>
                        )}
                    </Box>
                )}
            </div>
        );
    };

    return (
        <div>
            <div style={{ padding: "1% 2%", marginTop: "10px", marginBottom: "10px" }}>
                <div style={{ display: "flex", justifyContent: "flex-start", gap: "25px", alignItems: "center" }}>
                    <Typography fontWeight="bold" fontSize="16px">Referral:</Typography>
                    <div
                        className={requiredInferenceDiv(required) || "referralTagDefault"}
                        style={{
                            display: "flex",
                            whiteSpace: "nowrap",
                            borderRadius: "8px",
                            width: "fit-content",
                            padding: "10px",
                            alignItems: "center"
                        }}
                    >
                        <Typography fontSize="16px" fontWeight={400} className={requiredInferenceText(required) || ""}>{required ?? "—"}</Typography>
                    </div>
                </div>
            </div>

            <div className="web-view">
                <div style={{ display: "flex", justifyContent: "center", gap: "40px", padding: "0 2%", flexWrap: "wrap" }}>
                    <div style={{ width: "25vw", minWidth: "200px", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
                        <div id="hui" style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                            <Typography fontWeight={600} fontSize="20px" color="#051572">Right Eye</Typography>
                            {edit ? <IconButton onClick={() => handleImageEditClick("right")}>
                                <EditOutlinedIcon fontSize="small" sx={{ color: "#051572" }} />
                            </IconButton> : null}
                        </div>
                        <div style={{
                            width: "100%",
                            height: "32vh",
                            backgroundColor: rightImage ? "black" : "#f5f5f5",
                            border: "2px solid",
                            borderRadius: "8px",
                            boxShadow: "0px 2px 4px 1px rgba(0, 133, 13, 0.09), 0px 0px 6px 2px rgba(56, 142, 60, 0.26)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative"
                        }}
                            className={rightImage ? ImageDiv(rightInference) : ""}
                        >
                            {rightImage ? (
                                <>
                                    <img src={rightImage} style={{ height: "100%", width: "100%", objectFit: "contain" }} alt="right eye image" />
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "8px",
                                            left: "8px",
                                            cursor: "pointer",
                                            padding: "6px",
                                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)"
                                        }}
                                        onClick={() => { handleImageClick(rightImage, "Right"); setOpen(true); }}
                                    >
                                        <ZoomOutMapIcon style={{ fontSize: '20px', color: '#0D1E83' }} />
                                    </div>
                                </>
                            ) : (
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#666",
                                    textAlign: "center"
                                }}>
                                    <div style={{
                                        width: "60px",
                                        height: "60px",
                                        border: "2px solid #ccc",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        backgroundColor: "#fff"
                                    }}>
                                        <div style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #ccc",
                                            borderRadius: "4px",
                                            position: "relative"
                                        }}>
                                            <div style={{
                                                position: "absolute",
                                                top: "-2px",
                                                left: "-2px",
                                                width: "44px",
                                                height: "2px",
                                                backgroundColor: "#ccc",
                                                transform: "rotate(45deg)",
                                                transformOrigin: "center"
                                            }}></div>
                                        </div>
                                    </div>
                                    <Typography variant="body2" color="textSecondary">
                                        Image Not Available
                                    </Typography>
                                </div>
                            )}
                        </div>
                        {renderWebEyeInferenceBlock('right')}
                    </div>
                    <Divider orientation="vertical" variant="middle" flexItem sx={{ alignSelf: "stretch" }} />
                    <div style={{ width: "25vw", minWidth: "200px", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                            <Typography fontWeight={600} fontSize="20px" color="#051572">Left Eye</Typography>
                            {edit ? <IconButton onClick={() => handleImageEditClick("left")}>
                                <EditOutlinedIcon fontSize="small" sx={{ color: "#051572" }} />
                            </IconButton> : null}
                        </div>
                        <div style={{
                            width: "100%",
                            height: "32vh",
                            backgroundColor: leftImage ? "black" : "#f5f5f5",
                            border: "2px solid",
                            borderRadius: "8px",
                            boxShadow: "0px 2px 4px 1px rgba(0, 133, 13, 0.09), 0px 0px 6px 2px rgba(56, 142, 60, 0.26)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative"
                        }}
                            className={leftImage ? ImageDiv(leftInference) : ""}
                        >
                            {leftImage ? (
                                <>
                                    <img src={leftImage} style={{ height: "100%", width: "100%", objectFit: "contain" }} alt="left eye image" />
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "8px",
                                            left: "8px",
                                            cursor: "pointer",
                                            padding: "6px",
                                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)"
                                        }}
                                        onClick={() => { handleImageClick(leftImage, "Left"); setOpen(true); }}
                                    >
                                        <ZoomOutMapIcon style={{ fontSize: '20px', color: '#0D1E83' }} />
                                    </div>
                                </>
                            ) : (
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#666",
                                    textAlign: "center"
                                }}>
                                    <div style={{
                                        width: "60px",
                                        height: "60px",
                                        border: "2px solid #ccc",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        backgroundColor: "#fff"
                                    }}>
                                        <div style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #ccc",
                                            borderRadius: "4px",
                                            position: "relative"
                                        }}>
                                            <div style={{
                                                position: "absolute",
                                                top: "-2px",
                                                left: "-2px",
                                                width: "44px",
                                                height: "2px",
                                                backgroundColor: "#ccc",
                                                transform: "rotate(45deg)",
                                                transformOrigin: "center"
                                            }}></div>
                                        </div>
                                    </div>
                                    <Typography variant="body2" color="textSecondary">
                                        Image Not Available
                                    </Typography>
                                </div>
                            )}
                        </div>
                        {renderWebEyeInferenceBlock('left')}
                    </div>
                </div>
            </div>
            <div className="mobile-view">
                <Divider sx={{ background: "rgba(13, 30, 131, 0.22)" }} />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* <Typography fontWeight={600} fontSize="20px" color="#051572">Right Eye</Typography> */}
                    <Tabs value={view} onChange={handleTabChange} sx={{ '& .MuiTabs-indicator': { backgroundColor: "#051572", }, }}>
                        <Tab value="right" label="Right Eye" sx={{ textTransform: "none", color: view === 'right' ? "#051572" : "grey", '&.Mui-selected': { color: "#051572", }, }} />
                        <Tab value="left" label="Left Eye" sx={{ textTransform: "none", color: view === 'left' ? "#051572" : "grey", '&.Mui-selected': { color: "#051572", }, }} />
                    </Tabs>
                    {edit ? <IconButton onClick={handleImageEditClick}>
                        <EditOutlinedIcon fontSize="small" sx={{ color: "#051572" }} />
                    </IconButton> : null}
                </div>

                <div style={{
                    position: "relative",
                    width: "100%",
                    overflow: "hidden",
                    height: "auto",
                    minHeight: "50vh",
                    marginTop: "1rem",
                    marginBottom: "2rem"

                }}>
                    <div
                        style={{
                            display: "flex",
                            width: "200%", // 2 items
                            transition: "transform 0.5s ease",
                            transform: view === "right" ? "translateX(0%)" : "translateX(-41%)",
                        }}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                    >
                        {/* Right Eye View */}
                        <div style={{ width: "43%", marginRight: "8px", marginLeft: "1px", borderRadius: "8px", boxShadow: "0px 1px 4px 1px #00000014", boxSizing: "border-box" }}>
                            <div
                                style={{
                                    height: "30vh",
                                    backgroundColor: rightImage ? "black" : "#f5f5f5",
                                    border: "2px solid",
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px 1px rgba(0, 133, 13, 0.09), 0px 0px 6px 2px rgba(56, 142, 60, 0.26)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    opacity: view === "right" ? 1 : 0.5,

                                }}
                                className={rightImage ? ImageDiv(rightInference) : ""}
                            >
                                {rightImage ? (
                                    <>
                                        <img src={rightImage} style={{ height: "100%", width: "100%", objectFit: "contain" }} alt="right eye" />
                                        <div
                                            style={{ 
                                                position: "absolute", 
                                                bottom: 8, 
                                                left: 8, 
                                                cursor: "pointer", 
                                                padding: "6px",
                                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                                borderRadius: "4px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)"
                                            }}
                                            onClick={(e) => { e.stopPropagation(); handleImageClick(rightImage, "Right"); setOpen(true); }}
                                            onTouchStart={(e) => e.stopPropagation()}
                                            onTouchEnd={(e) => e.stopPropagation()}
                                        >
                                            <ZoomOutMapIcon style={{ fontSize: '20px', color: '#0D1E83' }} />
                                        </div>
                                    </>
                                ) : (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#666",
                                        textAlign: "center"
                                    }}>
                                        <div style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #ccc",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "8px",
                                            backgroundColor: "#fff"
                                        }}>
                                            <div style={{
                                                width: "25px",
                                                height: "25px",
                                                border: "2px solid #ccc",
                                                borderRadius: "3px",
                                                position: "relative"
                                            }}>
                                                <div style={{
                                                    position: "absolute",
                                                    top: "-2px",
                                                    left: "-2px",
                                                    width: "29px",
                                                    height: "2px",
                                                    backgroundColor: "#ccc",
                                                    transform: "rotate(45deg)",
                                                    transformOrigin: "center"
                                                }}></div>
                                            </div>
                                        </div>
                                        <Typography variant="body2" color="textSecondary" fontSize="12px">
                                            Image Not Available
                                        </Typography>
                                    </div>
                                )}
                            </div>
                            {renderMobileEyeInferenceBlock('right')}
                        </div>
                        {/* <Divider orientation="vertical" variant="middle" flexItem /> */}
                        {/* Left Eye View */}
                        <div style={{ width: "45%", marginRight: "4px", marginLeft: "8px", borderRadius: "8px", boxShadow: "0px 1px 4px 1px #00000014", boxSizing: "border-box" }}>
                            <div
                                style={{
                                    height: "30vh",
                                    backgroundColor: leftImage ? "black" : "#f5f5f5",
                                    border: "2px solid",
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px 1px rgba(0, 133, 13, 0.09), 0px 0px 6px 2px rgba(56, 142, 60, 0.26)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    opacity: view === "left" ? 1 : 0.5,
                                }}
                                className={leftImage ? ImageDiv(leftInference) : ""}
                            >
                                {leftImage ? (
                                    <>
                                        <img src={leftImage} style={{ height: "100%", width: "100%", objectFit: "contain" }} alt="left eye" />
                                        <div
                                            style={{ 
                                                position: "absolute", 
                                                bottom: 8, 
                                                left: 8, 
                                                cursor: "pointer", 
                                                padding: "6px",
                                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                                borderRadius: "4px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)"
                                            }}
                                            onClick={(e) => { e.stopPropagation(); handleImageClick(leftImage, "Left"); setOpen(true); }}
                                            onTouchStart={(e) => e.stopPropagation()}
                                            onTouchEnd={(e) => e.stopPropagation()}
                                        >
                                            <ZoomOutMapIcon style={{ fontSize: '20px', color: '#0D1E83' }} />
                                        </div>
                                    </>
                                ) : (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#666",
                                        textAlign: "center"
                                    }}>
                                        <div style={{
                                            width: "40px",
                                            height: "40px",
                                            border: "2px solid #ccc",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginBottom: "8px",
                                            backgroundColor: "#fff"
                                        }}>
                                            <div style={{
                                                width: "25px",
                                                height: "25px",
                                                border: "2px solid #ccc",
                                                borderRadius: "3px",
                                                position: "relative"
                                            }}>
                                                <div style={{
                                                    position: "absolute",
                                                    top: "-2px",
                                                    left: "-2px",
                                                    width: "29px",
                                                    height: "2px",
                                                    backgroundColor: "#ccc",
                                                    transform: "rotate(45deg)",
                                                    transformOrigin: "center"
                                                }}></div>
                                            </div>
                                        </div>
                                        <Typography variant="body2" color="textSecondary" fontSize="12px">
                                            Image Not Available
                                        </Typography>
                                    </div>
                                )}
                            </div>
                            {renderMobileEyeInferenceBlock('left')}
                        </div>
                    </div>
                </div>


            </div>
            {/* <div style={{ padding: "1% 2%" }}>
                <div>
                    <Typography fontWeight="bold" fontSize="16px">AI Generated Analysis</Typography>
                    <Typography color="#404040" fontWeight={400} fontSize="16px">
                        {rightInference} in the right eye, {leftInference} in the left eye. further medical examination is suggested.
                    </Typography>
                </div>
            </div> */}

            {/* Generic Radio Buttons - Only for Ophthalmologists */}
            {optometristRole === "Ophthalmologist" && !feedbackData && (
                <div style={{ padding: "1% 2%", marginTop: "20px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
                        {/* Service Provided */}
                        <div>
                            <Typography fontSize="18px" fontWeight="600" color="#000" style={{ marginBottom: "12px" }}>
                                Service Provided
                            </Typography>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                                {serviceProvidedOptions.map((option) => {
                                    const isNotNeededDisabled = option.value === 'not_needed' && isPositiveFinding;
                                    const optionDisabled = isDispositionLocked || isNotNeededDisabled;
                                    return (
                                    <div
                                        key={option.value}
                                        style={{
                                            border: "1px solid",
                                            borderRadius: "8px",
                                            padding: "4px 12px",
                                            borderColor: serviceProvided === option.value ? "#051572" : "#e0e0e0",
                                            backgroundColor: optionDisabled ? "#f0f0f0" : "#fff",
                                            whiteSpace: "nowrap",
                                            opacity: optionDisabled ? 0.6 : 1
                                        }}
                                    >
                                        <FormControlLabel
                                            value={option.value}
                                            control={
                                                <Radio
                                                    checked={serviceProvided === option.value}
                                                    onChange={handleServiceProvidedChange}
                                                    value={option.value}
                                                    disabled={optionDisabled}
                                                    sx={{
                                                        color: serviceProvided === option.value ? "#051572" : "default",
                                                        "&.Mui-checked": { color: "#051572" }
                                                    }}
                                                />
                                            }
                                            label={<Typography fontSize="16px" color="#000">{option.label}</Typography>}
                                        />
                                    </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Further Referral Required */}
                        <div>
                            <Typography fontSize="18px" fontWeight="600" color="#000" style={{ marginBottom: "12px" }}>
                                Further Referral Required
                            </Typography>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                            <div style={{
  border: "1px solid",
  borderRadius: "8px",
  padding: "4px 12px",
  borderColor: furtherReferralRequired === 'yes' ? "#051572" : "#e0e0e0",
  backgroundColor: isDispositionLocked ? "#f0f0f0" : "#fff",
  whiteSpace: "nowrap",
  opacity: isDispositionLocked ? 0.6 : 1
}}>
  <FormControlLabel
    value="yes"
    control={
      <Radio
        checked={furtherReferralRequired === 'yes'}
        onChange={handleFurtherReferralRequiredChange}
        value="yes"
        disabled={isDispositionLocked}
        sx={{
          color: furtherReferralRequired === 'yes' ? "#051572" : "default",
          "&.Mui-checked": { color: "#051572" }
        }}
      />
    }
    label={<Typography fontSize="16px" color="#000">Yes</Typography>}
  />
</div>
<div style={{
  border: "1px solid",
  borderRadius: "8px",
  padding: "4px 12px",
  borderColor: furtherReferralRequired === 'no' ? "#051572" : "#e0e0e0",
  backgroundColor: isDispositionLocked ? "#f0f0f0" : "#fff",
  whiteSpace: "nowrap",
  opacity: isDispositionLocked ? 0.6 : 1
}}>
  <FormControlLabel
    value="no"
    control={
      <Radio
        checked={furtherReferralRequired === 'no'}
        onChange={handleFurtherReferralRequiredChange}
        value="no"
        disabled={isDispositionLocked}
        sx={{
          color: furtherReferralRequired === 'no' ? "#051572" : "default",
          "&.Mui-checked": { color: "#051572" }
        }}
      />
    }
    label={<Typography fontSize="16px" color="#000">No</Typography>}
  />
</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#e0e0e0", marginTop: "30px" }}></div>
                </div>
            )}

            {/* Display Feedback Information when submitted */}
            {feedbackData && (
                <div style={{ padding: "1% 2%", marginTop: "20px" }}>
                    <Typography fontSize="18px" fontWeight="600" color="#051572" style={{ marginBottom: "16px" }}>
                        Assessment completed
                    </Typography>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        {feedbackData.treatment_provided && (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Typography fontSize="16px" fontWeight="500" color="#000">
                                    Service provided:
                                </Typography>
                                <Typography fontSize="16px" color="#051572" fontWeight="600">
                                    {serviceProvidedOptions.find((o) => o.value === feedbackData.treatment_provided)?.label
                                        || (feedbackData.treatment_provided === 'yes' ? 'Yes' : 'No')}
                                </Typography>
                            </div>
                        )}
                        {feedbackData.further_referral_required && (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Typography fontSize="16px" fontWeight="500" color="#000">
                                    Further Referral Required:
                                </Typography>
                                <Typography fontSize="16px" color="#051572" fontWeight="600">
                                    {feedbackData.further_referral_required === 'yes' ? 'Yes' : 'No'}
                                </Typography>
                            </div>
                        )}
                    </div>
                    <div style={{ width: "100%", height: "1px", backgroundColor: "#e0e0e0", marginTop: "20px" }}></div>
                </div>
            )}

            <div style={{ padding: "1% 2%" }}>
                <div>
                    <Typography fontSize="16px" fontWeight="bold">Next Steps</Typography>
                    <Typography fontSize="16px" fontWeight={400}>
                        Suggestion:&nbsp;
                        <Typography component="span" fontWeight={500} sx={{ whiteSpace: "pre-line" }}>
                            {message}
                        </Typography>
                    </Typography>
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md" eye={eye}>
                <DialogTitle>
                    Captured image of patient's {eye} eye
                    <IconButton onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <img src={selectedImage} alt="Eye preview" style={{ width: "100%", height: "auto" }} />
                </DialogContent>
            </Dialog>

        </div>
    );

})

export default InferenceDetailsComponent